import EditSolution from './EditSolution';
import NewSolution from './components/NewSolution';

export { NewSolution };
export default EditSolution;
